import styled, { css } from 'styled-components';
import { HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS } from 'common/components/TouchpointEditor/components/TouchpointContainer';

const BEFORE_ICON_CSS = css`
    grid-template-columns: auto 1fr;
    column-gap: 1rem;
`;

export const DefaultLinkComponent = styled.a`
    padding: 0;
    border: none;
    font: inherit;
    background: none;
    display: grid;
    align-items: center;
    outline-style: none;
    min-width: 2rem;
    color: ${(props) => props.buttonStyles.$fontColor};
    font-family: '${(props) => props.buttonStyles.$fontFamily}', sans-serif;
    font-size: ${(props) => props.buttonStyles.$fontSize}px;
    ${(props) => (props.hasBeforeIcon ? BEFORE_ICON_CSS : '')};

    // Enable highlight and content editing styles.
    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}

    &:hover,
    &:active {
        color: ${(props) => props.buttonStyles.$fontColorHover};
    }

    &:focus {
        outline-style: auto;
    }
`;
